// @ts-check
import { getPlotNumbersByGroup, returnContainsStatusFromPlotNumbers, getMatchedPlotNumbers } from './plotNumberHelpers';

/**
 * @param {import('../types').Shape[]} shapes
 * @param {import('../types').PlotNumber[]} plotNumbers
 * @param {import('../types').Group[]} groups
 * @param {import('../types').Shape | null} selectedShape
 * @param {import('../types').StatusForMap[]} statuses
 * @param {boolean} isFiltersActive
 * @returns
 */
const getShapesForSvgMap = (shapes, plotNumbers, groups, selectedShape, statuses, isFiltersActive) => (
	shapes.filter(shape => plotNumbers.findIndex(plotNumber => plotNumber.id === getPlotNumberIdFromShapeLink(shape.link)) >= 0 || groups.findIndex(group => group.id === getGroupIdFromShapeLink(shape.link)) >= 0).map(shape => {
		const plotNumber = plotNumbers.find(plotNumber => plotNumber.id === getPlotNumberIdFromShapeLink(shape.link));
		const group = groups.find(group => group.id === getGroupIdFromShapeLink(shape.link));

		if (!plotNumber && !group) {
			return null;
		}

		let statusValue = null;
		if (plotNumber) {
			statusValue = plotNumber?.status.value;
		}

		let plotNumbersByGroup = [];
		if (group) {
			// TODO: better to get the status values from BOUWNUMMERS()->getStatusFieldChoices() in order
			plotNumbersByGroup = getPlotNumbersByGroup(group, isFiltersActive ? getMatchedPlotNumbers(plotNumbers) : plotNumbers);
			statusValue = returnContainsStatusFromPlotNumbers(plotNumbersByGroup, ['available', 'in-option', 'sold', 'not-yet-available']);
		}

		return {
			...shape,
			status: statusValue,
			isMatch: plotNumber ? plotNumber?.isMatch : plotNumbersByGroup.length > 0,
			isHighlighted: !!group || statuses.filter(status => status.isSelected).map(status => status.value).indexOf(plotNumber.status.value) >= 0, // WIP
			isSelected: selectedShape && shape.id === selectedShape.id
		};
	}).filter(shape => shape)
);

/**
 * @param {string} link
 * @returns {number?}
 */
const getPlotNumberIdFromShapeLink = (link) => {
	const parts = link.split(':');
	return parts[0] === 'plot-number' ? parseInt(parts[1], 10) : null;
};

/**
 * @param {string} link
 * @returns {string?}
 */
const getGroupIdFromShapeLink = (link) => {
	const parts = link.split(':');
	return parts[0] === 'group' ? parts[1] : null;
};

export {
	getShapesForSvgMap,
	getPlotNumberIdFromShapeLink,
	getGroupIdFromShapeLink
};